import './scss/rivandy.scss';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Bounce from 'react-reveal/Bounce';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

function Header() {
  const location = useLocation();
  const { pathname } = location;
  const settings = useSelector((state) => state);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  const isActive = (path) => {
    if (path === '/') return pathname === '/';
    return pathname === path || pathname.startsWith(`${path}/`);
  };

  const linkClass = (path) =>
    isActive(path) ? `${settings.factionSelected === 1 || settings.factionSelected === 0 ? 'rivandy-color' : 'dechys-color'} selected-link` : null;

  return (
    <header id="menu-rivandy">
      <Bounce top cascade>
        <section id="m-left">
          <a href="/">
            <img
              id={settings.factionSelected === 1 || settings.factionSelected === 0 ? 'rivandy-logo' : 'rivandy-logoD'}
              src={process.env.PUBLIC_URL + (settings.factionSelected === 1 || settings.factionSelected === 0 ? '/img/rivandy-s.png' : '/img/dechys-h.png')}
              alt="Rivandy logo"
            />
          </a>
          <button className="nav-toggle" aria-label="Toggle navigation" onClick={() => setMenuOpen((v) => !v)}>
            <span />
            <span />
            <span />
          </button>
          <ul className={menuOpen ? 'nav-open' : ''}>
            <li>
              <Link className={linkClass('/')} to="/" onClick={() => setMenuOpen(false)}>
                Home
              </Link>
            </li>
            <li>
              <a href="https://discord.gg/RmubB8KhRW" target="_blank" rel="noreferrer">
                Discord
              </a>
            </li>
            <li>
              <a href="https://store.steampowered.com/app/2713480/Rivandy/" target="_blank" rel="noreferrer">
                Steam
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/@RivandyOnline" target="_blank" rel="noreferrer">
                Youtube
              </a>
            </li>
            <li>
              <Link className={linkClass('/ranking')} to="/ranking" onClick={() => setMenuOpen(false)}>
                Ranking
              </Link>
            </li>
            <li>
              <Link className={linkClass('/history')} to="/history" onClick={() => setMenuOpen(false)}>
                History
              </Link>
            </li>
            <li>
              <Link className={linkClass('/statistics')} to="/statistics" onClick={() => setMenuOpen(false)}>
                Statistics
              </Link>
            </li>
            <li>
              <Link className={linkClass('/player')} to="/player" onClick={() => setMenuOpen(false)}>
                Profile
              </Link>
            </li>
            {/* <li><Link className={pathname === '/news' ? ((settings.factionSelected === 1 || settings.factionSelected === 0 ? 'rivandy-color' : 'dechys-color') + ' selected-link') : 'disabled-link'} to="/">News</Link></li>
            <li><Link className={pathname === '/downloads' ? ((settings.factionSelected === 1 || settings.factionSelected === 0 ? 'rivandy-color' : 'dechys-color') + ' selected-link') : 'disabled-link'} to="/">Download</Link></li>
          */}{' '}
          </ul>
        </section>
      </Bounce>
    </header>
  );
}

export default Header;
